/**
* Nom : documentTypeList.js
* Description : Ce fichier contient la définition de la page documentTypeList 
*               Cette page liste les types de document pour des produits
* Date de création : 25 septembre 2025
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'
import { DeleteIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';
import { BackPage } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react';
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* DocumentTypeList : affiche la page qui liste les types de document pour les produits
*                    un lien permet d'afficher un formulaire pour créer un nouveau type de document
*                    pour chaque type une icone permet de le supprimer
*
* Type : page 
*
* Parametres : 
*  None
*/
function DocumentTypeList() {

  // Define useState hooks

  const [statusDocumentType, setStatusDocumentType] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)
  const [isCreation, setCreation] = useState(false)
  const [documentTypes, setDocumentTypes] = useState([]);
  const [name, setName] = useState(null);
  const [nameError, setNameError] = useState(false);
  const [isFormClicked, setFormClicked] = useState(false);


  // Define useContext hooks
  const { authStatus, authToken, currentUser } = useAuth();
  const { path } = useApi();


  // Define useBlocker hooks
  const shouldBlock = isCreation;
  const blocker = useBlocker(shouldBlock);


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();
  

  // Define functions
  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Document types
    const resDocumentType = await fetch(path + "/api/eq-doty/", 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const dataDocumentType = await resDocumentType.json();
    setStatusDocumentType(resDocumentType["status"])
    setDocumentTypes(dataDocumentType["results"])
    // Dataloading
    setDataLoading(false)
  }

  const handleClick = (event) => {
    event.preventDefault();
    setCreation(true)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormClicked(true)
    if(name === null || name === ''){
      setNameError(true)
    }
    else
    {   
      setNameError(false)
    }
  };

  const handleReset = (event) => {
    event.preventDefault();
    setCreation(false)
    setName(null)
    setNameError(false)
  };

  async function sendData(name) {
    // Token
    const token = "Bearer " + authToken
    // Retrieve target details
    await fetch(path + "/api/eq-doty/", 
      {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
        },
        body: JSON.stringify({
            "name": name
        })
      }
    );
    setCreation(false)
    setName(null)
    retrieveData()
    setFormClicked(false)
  }

  const handleIcon = (event, id) => {
    event.preventDefault();
    sendDelete(id)
  };

  async function sendDelete(id) {
    // Token
    const token = "Bearer " + authToken
    // Retrieve at_report details
    await fetch(path + "/api/eq-doty/" + id + "/", 
      {
        method: 'DELETE',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
        }
      }
    );
    retrieveData()
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(nameError === false && isFormClicked === true){
      sendData(name)
    } else {
      setFormClicked(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFormClicked])

  useEffect(() => {
      // Bloquer la fermeture d'onglet/rafraîchissement
      const handleBeforeUnload = (e) => {
      if (shouldBlock === true) {
          // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
          e.preventDefault();
          e.returnValue = "";
          // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
          return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
      }
      }; 

      window.addEventListener("beforeunload", handleBeforeUnload);

      // Nettoyer l'écouteur quand le composant est démonté
      return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBlock]);

  useEffect(() => {
      if (blocker.state === "blocked") {
          const confirmed = window.confirm(
              "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
          );

          if (confirmed) {
              blocker.proceed();
          } else {
              blocker.reset();
          }
      }
  }, [blocker]);


  // Render component
  return (
    <div>
      <TabC tabNumber={1}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusDocumentType === 200) ? (
              <div>
                <h1>Types de document</h1>  
                {/*Lien de retour*/}
                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                  <div className='link-border'>
                    <BackPage path='/documents'>Retour à la liste des documents</BackPage>
                  </div>
                </div>
                <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                  {/*New*/}
                  <div className='flex-column'>
                    <div className='link' onClick={handleClick}>
                      <img src={AddIcon} alt='add_item_icon' className='link-img' />
                      <div className='link-text'>Type</div>
                    </div>
                    {(isCreation === true) ? (
                      <div className='flex-rows'>
                        <h3>Nouveau type de document</h3>
                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                          <div className='flex-column form-center'>
                            <InputFormSide error={nameError} type="text" label="Nom" value={name} setValue={setName}/>
                          </div>
                          <div className='flex-row form-center'>
                            <button type="reset" className='button'>Annuler</button>
                            <button type="submit" className='button'>Valider</button>
                          </div>
                        </form> 
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                  {(screenWidth > 650) ? null : <Divider/>}
                  {/*Document type list*/}
                  <div className='scroll-list-rd'>
                    {(documentTypes && documentTypes.length !== 0) ? (
                      documentTypes.sort((a, b) => (a.name > b.name)?1:-1).map((type) => (
                        <Item key={type['id']} id={type['id']}>
                          <div className='grid-1-1'>
                            <h3 className='item-text'>{type['name']}</h3>
                            <div className='flex-row justify-end'>
                              <div/>
                              { (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? (
                                  <img src={DeleteIcon} alt='delete_item_icon' onClick={(e) => handleIcon(e, type['id']) } className='link-img'/>
                                ) : (
                                  <p/>
                                )
                              }
                            </div>
                          </div>
                        </Item>
                      ))
                    ) : (
                      <p>Aucun type de document actuellement. Veuillez en créer un !</p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default DocumentTypeList;
